import { render, staticRenderFns } from "./SplashContainer.vue?vue&type=template&id=e9a120a8"
import script from "./SplashContainer.vue?vue&type=script&lang=js"
export * from "./SplashContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports